import React from 'react';
import "./Footer.scss";

const Footer = () => {
    return (
        <footer className='footer' role="contentinfo">
            <div className='container'>
                <div className='footer__content'>
                    <p className='footer__copyright'>©2025 CopyRight Example. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;